import { Box, Typography, Stack } from '@mui/material';

import { styled } from '@mui/material/styles';
import BgImagePng from '@/assets/images/auth/login-bg-image.png?imagetools&format=png&as=url';
import BgImageWebp from '@/assets/images/auth/login-bg-image.png?imagetools&format=webp&as=url';
import RapidWorksLogo from '@/assets/images/auth/rapidworks-logo.svg';

const Wrapper = styled('div')(({ theme }) => ({
  backgroundImage: `image-set(url(${BgImageWebp}) type("image/webp") 1x, url(${BgImagePng}) type("image/png") 1x)`,
  backgroundColor: theme.palette.grey[300],
  padding: 8,
  borderRadius: 4,
  width: '100vw',
  minHeight: '100vh',
  height: '100vh',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'contain',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}));

interface ErrorWrapperProps {
  title?: string;
  children?: React.ReactNode;
}

const ErrorWrapper: React.FC<ErrorWrapperProps> = ({ title, children }) => {
  return (
    <Wrapper>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
        <img src={RapidWorksLogo} alt="Rapid Works Logo" loading="lazy" decoding="async" />
        <Stack spacing={0.5} sx={{ marginTop: '25px', textAlign: 'center' }}>
          <Typography variant="h5" fontWeight={600}>
            {title}
          </Typography>
          <Typography variant="body1">{children}</Typography>
        </Stack>
      </Box>
    </Wrapper>
  );
};

export default ErrorWrapper;
